import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateStagesetStarter as CreateStagesetStarterMutation,
    CreateStagesetStarterVariables as CreateStagesetStarterVariables,
    StagesetStarterCreateInput,
} from 'nutshell-graphql-types';

import CREATE_STAGESET_STARTER from '../mutations/create-stageset-starter.graphql';

export const useCreateStagesetStarter = (): {
    createStagesetStarter: (arg1: StagesetStarterCreateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createStagesetStarter, {loading, error}] = useMutation<
        CreateStagesetStarterMutation,
        CreateStagesetStarterVariables
    >(CREATE_STAGESET_STARTER);

    return {
        createStagesetStarter: (input: StagesetStarterCreateInput) =>
            createStagesetStarter({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
